import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  insurance: {
    defaultMessage: 'Insurance',
    description: 'costReviewModal.insuranceSubtotal',
    id: '0/KWg3',
  },
  confirmation: {
    defaultMessage: 'Confirmation',
    description: 'costReviewModal.confirmationSubtotal',
    id: 'RtC1cr',
  },
  additionalCharges: {
    defaultMessage: 'Additional Charges',
    description: 'costReviewModal.otherCostsSubtotal',
    id: 'tPftO8',
  },
});
